// extracted by mini-css-extract-plugin
module.exports = {"pageInfo":"styles_pageInfo__3Bp8M","dataInfo":"styles_dataInfo__3RlEQ","item":"styles_item__2v04A"};